export const LastNameFieldData = {
  formControlName: 'lastName',
  id: 'grit-field-last-name',
  type: 'text',
  label: 'Last name',

  validationList: [
    {
      errorKey: 'cannotContainNumbers',
      message: 'Your last name cannot contain any numbers.',
    },
    {
      errorKey: 'startWithALetter',
      message: 'Your last name must start with a letter.',
    },
    {
      errorKey: 'pattern',
      args: ["^[a-zA-Z '-]+$"],
      message:
        "Your last name can't contain any numbers or special characters other than dash (-), apostrophe(') or a space.",
    },
  ],
  required: true,
  requiredMessage: 'Your last name is required to process the application.',
};
